import React from 'react'
import './OEIPopover.css'
import OEIAddText from './OEIAddText';
import { getEmailList } from './OEIUtils'
import OEIInput from './OEIInput';
import AddNewEmailModel from './AddNewEmailModel';
import { EMPTY } from './Constants';

export default function NewNotification(props) {

    const setSelectedValue = (value) => {
        props.setNewData({ ...props.newData, selectedValue: value });
        props.setErrors({ ...props.errors, error1: EMPTY })

    }
    const removeEmail = (type, email) => {
        if (type === 'all') {
            var list = getEmailList(props.newData.allEmails);
            const index = list.indexOf(email);
            if (index > -1) {
                list.splice(index, 1);
            }
            props.setNewData({ ...props.newData, allEmails: list.toString() })
        } else {
            var list = getEmailList(props.newData.emails);
            const index = list.indexOf(email);
            if (index > -1) {
                list.splice(index, 1);
            }
            props.setNewData({ ...props.newData, emails: list.toString() })
        }
    }
    return (
        <>
            <div className="oe-form-field">
                <label className="oe-form-field__title" >{props.name}</label>
                <select className="oe-form-field__control" value={props.newData.selectedValue} onChange={e => { setSelectedValue(e.target.value) }}>
                    <option value={'Event created'}>{'Event Created'}</option>
                    <option value={'Event Edited'}>{'Event edited'}</option>
                    <option value={'Event status changed'}>{'Event status changed'}</option>
                    <option value={'Event created starting in under 24 hours'}>{'Event created starting in under 24 hours'}</option>
                    <option value={'Artifacts Issue Alert'}>{"Artifacts Issue Alert"}</option>
                    <option value={'Artifacts Delivered'}>{"Artifacts Delivered"}</option>
                    <option value={'Registration failed'}>{"Registration failed"}</option>
                </select>
                {props.errors.error1 !== EMPTY ?
                    <div className="oe-form-field__error">{props.errors.error1}</div>
                    : EMPTY
                }
            </div>        
             <OEIAddText type='new'editData={props.editData} setNewData={props.setNewData}email={props.email}cancelEmailAdding={props.cancelEmailAdding}emailId={props.emailId}setEmailid={props.setEmailid}error={props.error}setError={props.setError}toggeleChecked={props.toggeleChecked}onChangeToggle={props.onChangeToggle}addEmail={props.addEmail}newData={props.newData}selectedValue={props.newData.selectedValue} removeEmail={removeEmail} allEmails={getEmailList(props.newData.allEmails)} error2={props.errors.error2} setErrors={props.setErrors}  setEmail={props.setEmail} emailList={getEmailList(props.newData.emails)}></OEIAddText>
        </>
    )
}
